`<template>
  <div>
    <Form ref="applicationForm" :model="application" :rules="applicationRules" inline :label-width="125">
      <Row>
        <Col span="8">
          <FormItem label="申请人（经销商）">
            <p class="form-static">{{application.cusName}}</p>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="促销时间" prop="num">
            <p class="form-static">{{application.salesBeginDate}} - {{application.salesEndDate}}</p>
          </FormItem>
        </Col>
      </Row>
      <Table :columns="viewColumns" :data="application.salesSkus" size="small">
      </Table>
      <FormItem prop="salesSkus">
        <Input type="text" placeholder="请添加条码" style='display: none'>
        </Input>
      </FormItem>
      <Row>
        <Col span="8">
          <FormItem label="含税金额" prop="totalAmountTax">
            <p class="form-static">{{amountFormat(application.totalAmountTax)}}</p>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="折让金额" prop="tjzrAmount">
            <p class="form-static">{{amountFormat(application.tjzrAmount)}}</p>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="8" v-for="item in uploadList" :key="item.code">
          <FormItem :label="item.title">
            <Uploader :target="item.code" :docCode="application.docCode" :defaultFileList="item.defaultFileList" :downloadPath.sync="item.path" />
          </FormItem>
        </Col>
      </Row>
      <Row v-if="application.spList && application.spList.length > 0">
        <Col span="16">
          <CTable :columns="auditColumns" :data="application.spList"/>
        </Col>
        <FormItem></FormItem>
      </Row>
    </Form>
  </div>
</template>

<script>
  import CTable from '@/components/CTable'
  import BtnEvent from '@/components/BtnEvent'
  import Uploader from '@/components/Uploader'
  import { timeFormat, timeDiff, amountFormat } from '@/plugin/tool'
  import { salesAppliRules } from '@/plugin/validateRule'
  import { salesFileList } from '@/plugin/enum'
  export default {
    name: 'SalesApplication',
    mixins: [ BtnEvent ],
    components: {
      CTable,
      Uploader
    },
    data() {
      return {
        cusList: [],
        date: [],
        typeList: [],
        status: false,
        application: {
          anStatus: null,
          dptCode: '',
          userCode: '',
          movieNum: '',
          salesSkus: [],
          totalAmountTax: null,
          tjzrAmount: null
        },
        applicationRules: salesAppliRules,
        tableRules: {
          taxAmount: [{
            required: true,
            message: '请输入',
            trigger: 'blur'
          }]
        },
        showProductModal: false,
        viewData: {
          page: 1,
          pageSize: 10
        },
        total: 0,
        columns: [{
          type: 'selection',
          width: 60,
          align: 'center'
        }, {
          title: '存货名称',
          key: 'skuName',
        }, {
          title: '供价',
          key: 'offerPrice',
        }],
        selections: [],
        queryData: [],
        viewColumns: [{
          title: '序号',
          key: 'docCode',
          minWidth: 60,
          render: (h, params) => {
            return h('div', params.index + 1)
          }
        }, {
          title: '存货名称',
          key: 'skuName',
          minWidth: 90
        }, {
          title: '数量',
          key: 'number',
          minWidth: 90
        }, {
          title: '含税金额',
          key: 'taxAmount',
          minWidth: 110,
          render: (h, params) => {
            return h('span', amountFormat(params.row.taxAmount))
          }
        }, {
          title: '类型',
          key: 'ssType',
          minWidth: 100,
          render: (h, params) => {
            let _ssType = null
            this.typeList.map(item => {
              if (item.id === params.row.ssType) {
                _ssType = item.name
              }
            })
            return h('span', _ssType)
          }
        }, {
          title: '百分比（%）',
          key: 'bfb',
          minWidth: 100
        }, {
          title: '折让金额',
          key: 'allowanceAmount',
          minWidth: 90,
          render: (h, params) => {
            return h('span', amountFormat(params.row.allowanceAmount))
          }
        }],
        auditColumns: [{
          title: '审核人',
          key: 'userName',
          align: 'center'
        }, {
          title: '审核意见',
          key: 'info',
          align: 'center'
        }, {
          title: '审核时间',
          key: 'createTime',
          align: 'center'
        }],
        fileList: salesFileList,
        uploadList: []
      }
    },
    created() {
      if (this.$route.query.id) {
        this.init()
      }
      this.getList()
    },
    methods: {
      amountFormat: amountFormat,
      init() {
        this.$fetch('SalesPromo/getById', {
          spType: '1',
          id: this.$route.query.id
        }).then(res => {
          if (res.data) {
            this.application = res.data
            this.date = [res.data.salesBeginDate, res.data.salesEndDate]
            this.typeList = this.application.uploadcodes.split(",") // 已上传列表
            this.typeList.map(item => {
              this.fileList.map(val => {
                if (item === val.code) {
                  const path = res.data[item]
                  this.uploadList.push(Object.assign({}, val, {
                    path: path ? path : '',
                    defaultFileList: path ? [{
                      url: path,
                      name: path.split("file/")[1]
                    }] : []
                  }))
                console.log(this.uploadList)
                }
              })
            })
          }
        })
      },
      getList() {
        this.$fetch('XxOption/getList').then(res => {
          this.typeList = res.data.list
          console.log(this.typeList)
        })
      }
    }
  }
</script>